import { CssBaseline } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import Header from '../components/header/header';
import AppRoutes from '../routes/app-routes';
import { useKeycloak } from '@react-keycloak/web';

import { useEffect } from 'react';
import { GlobalStore, useStore } from '../store';
import Toast from '../components/Toast';

const AppLayout = () => {
  const { keycloak } = useKeycloak();
  const { dispatch } = useStore()

  useEffect(() => {

    //to catch logged out event
    keycloak.onAuthLogout = () => {
      dispatch({ type: 'PURGE_STATE', payload: null })
    }

    keycloak.onTokenExpired = () => {
      keycloak.updateToken(50).then((refreshed: boolean) => {
        if (refreshed) {
          console.log('keycloak token refreshed ');
        } else {
          console.log('token is still valid');
        }
      }).catch((e: Error) => {
      });

    }

    keycloak.onReady = async (authenticated: boolean) => {
    };
  }, []);

  return (
    <>
      <Header />
      <main id={"MainContainer"}>
        <AppRoutes />
      </main>
    </>
  );
};

function App() {

  return (
    <GlobalStore>
      <BrowserRouter>
        <CssBaseline />
        <AppLayout />
        <Toast />
      </BrowserRouter>
    </GlobalStore>
  );
}

export default App;
